import { parse } from "@config/theme";
import { css } from "linaria";
export const container = parse({
  position: 'relative',
  width: '100%'
});
export const video = parse({
  position: 'absolute',
  width: '100%',
  height: '100%'
}, "vq36zer");

require("./Video.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Video.styles.ts");